import { render } from "./ListeFaq.vue?vue&type=template&id=4d230f29&ts=true"
import script from "./ListeFaq.vue?vue&type=script&lang=ts"
export * from "./ListeFaq.vue?vue&type=script&lang=ts"

import "./ListeFaq.vue?vue&type=style&index=0&id=4d230f29&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__